var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClaimSocialColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 21,
  viewBox: "0 0 25 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.21 18.019s-1.315 0-1.315-1.251c0-1.252 1.315-5.006 7.894-5.006 6.58 0 7.895 3.754 7.895 5.006 0 1.251-1.316 1.251-1.316 1.251H2.21Zm6.58-7.508c1.046 0 2.05-.396 2.79-1.1a3.663 3.663 0 0 0 1.157-2.654c0-.996-.416-1.95-1.156-2.655a4.053 4.053 0 0 0-2.792-1.1c-1.047 0-2.05.396-2.79 1.1a3.663 3.663 0 0 0-1.157 2.655c0 .996.416 1.95 1.156 2.654s1.744 1.1 2.791 1.1Z",
  fill: "#FFB801"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.56 12.156c1.515.818 2.353 1.913 2.783 2.86h5.832s.877 0 .877-.835c0-.834-.877-3.336-5.263-3.336-2.149 0-3.455.6-4.229 1.311Zm6.09-2.879a2.702 2.702 0 0 1-1.86.733 2.702 2.702 0 0 1-1.861-.733 2.442 2.442 0 0 1-.771-1.77c0-.663.277-1.3.77-1.77a2.702 2.702 0 0 1 1.861-.732c.698 0 1.368.264 1.861.733.494.47.77 1.106.77 1.77 0 .663-.276 1.3-.77 1.77Z",
  fill: "#FFB801"
})));
export default SvgClaimSocialColor;